module.exports = __webpack_public_path__ + "static/elon-png-92710d86ebe30b8b354d7e87d34d924d.png";